import React from "react";

/** Placeholder cards shown while the catalog loads (instead of "Загрузка…"). */
export function ProductGridSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid-2" aria-busy="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i}>
          <div className="skeleton" style={{ aspectRatio: "4 / 5", borderRadius: "var(--radius-s)" }} />
          <div className="skeleton" style={{ height: 9, width: "40%", marginTop: 14 }} />
          <div className="skeleton" style={{ height: 16, width: "80%", marginTop: 9 }} />
          <div className="skeleton" style={{ height: 11, width: "95%", marginTop: 9 }} />
          <div className="skeleton" style={{ height: 15, width: "50%", marginTop: 14 }} />
        </div>
      ))}
    </div>
  );
}

export function ProductPageSkeleton() {
  return (
    <div aria-busy="true">
      <div className="skeleton" style={{ height: 330, borderRadius: "var(--radius-s)" }} />
      <div className="skeleton" style={{ height: 10, width: "30%", marginTop: 20 }} />
      <div className="skeleton" style={{ height: 28, width: "70%", marginTop: 12 }} />
      <div className="skeleton" style={{ height: 22, width: "40%", marginTop: 18 }} />
      <div className="skeleton" style={{ height: 12, width: "100%", marginTop: 24 }} />
      <div className="skeleton" style={{ height: 12, width: "92%", marginTop: 10 }} />
      <div className="skeleton" style={{ height: 12, width: "80%", marginTop: 10 }} />
    </div>
  );
}
